const CardHolder = ({children}) => {
    return (
        <div key={Math.random()} className="card-viewer-card-holder animate__animated animate__fadeInRight" >
            {children}
        </div>)
}

export default CardHolder